// /cms-frontend/cms-frontend/src/utils/validators.ts

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePassword = (password: string): boolean => {
  // Password must be at least 8 characters long and contain at least one number and one letter
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
  return passwordRegex.test(password);
};

export const validateRequiredField = (value: string): boolean => {
  return value.trim().length > 0;
};

export const validateStudentId = (studentId: string): boolean => {
  // Assuming student ID should be alphanumeric and 6-10 characters long
  const studentIdRegex = /^[a-zA-Z0-9]{6,10}$/;
  return studentIdRegex.test(studentId);
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  // Kenyan phone number validation (supports formats: 0712345678, +254712345678, 254712345678)
  const phoneRegex = /^(\+?254|0)[17]\d{8}$/;
  return phoneRegex.test(phoneNumber);
};
